/**
 * Sprint 3.4 — lightweight client-side filter/sort for admin tables (no query engine).
 */

/**
 * @param {Array<Record<string, unknown>>} rows
 * @param {string[]} columnKeys
 * @param {string} search trimmed lower search across primitive columns
 * @param {Record<string, string>} columnFilters key -> substring filter (lowercase match)
 */
export function filterAdminTableRows(rows, columnKeys, search, columnFilters) {
  let out = [...(rows || [])];
  const s = (search || '').trim().toLowerCase();
  const keys = columnKeys || [];

  if (s) {
    out = out.filter((row) =>
      keys.some((k) => {
        const v = row[k];
        if (v == null) return false;
        if (typeof v === 'object') return false;
        return String(v).toLowerCase().includes(s);
      })
    );
  }

  Object.entries(columnFilters || {}).forEach(([k, raw]) => {
    const f = (raw || '').trim().toLowerCase();
    if (!f) return;
    out = out.filter((row) => {
      const v = row[k];
      if (v == null) return false;
      if (typeof v === 'object') return false;
      return String(v).toLowerCase().includes(f);
    });
  });

  return out;
}

/**
 * @param {string|null} prevKey
 * @param {'asc'|'desc'|null} prevDir
 * @param {string} clickedKey
 * @returns {{ key: string|null, dir: 'asc'|'desc'|null }}
 */
export function nextSortState(prevKey, prevDir, clickedKey) {
  if (prevKey !== clickedKey) return { key: clickedKey, dir: 'asc' };
  if (prevDir === 'asc') return { key: clickedKey, dir: 'desc' };
  return { key: null, dir: null };
}

export function sortAdminTableRows(rows, sortKey, sortDir) {
  if (!sortKey || !sortDir) return [...(rows || [])];
  const mult = sortDir === 'asc' ? 1 : -1;
  return [...(rows || [])].sort((a, b) => {
    const va = a[sortKey];
    const vb = b[sortKey];
    const na = Number(va);
    const nb = Number(vb);
    if (Number.isFinite(na) && Number.isFinite(nb) && String(va).trim() !== '' && String(vb).trim() !== '') {
      return (na - nb) * mult;
    }
    return String(va ?? '').localeCompare(String(vb ?? ''), undefined, { sensitivity: 'base' }) * mult;
  });
}
